<div class="blotter-selector-wrapper">
  <div #wrapper class="bfx-multi-selector">
    <input
      [disabled]="disableInput"
      [hidden]="!showOptions"
      #entry
      placeholder="Filter"
      type="search"
      class="bfx-find-filter-selector--input constrained ui-autocomplete-input ui-autocomplete-dd-input ui-inputtext ui-corner-all ui-state-default ui-widget ui-state-filled ui-cell-editing"
      (focus)="onInputFocus($event)"
      [ngModel]="text"
      (ngModelChange)="textChanged($event)"
    />
    <bfx-icon-button
      #selectorButton
      [disabled]="disableInput"
      size="xs"
      iconClass="icon-ion_chevron_down"
    >
    </bfx-icon-button>
    <label
      (click)="showOptionsOnClick()"
      [hidden]="true"
      [ngStyle]="{'cursor': disableInput ? 'default':'pointer'}"
      style="cursor: none"
      >{{selectedOptionText}}
    </label>
  </div>
  <div
    #dropdown
    class="bfx-multi-selector-dropdown bfx-find-filter-selector--dropdown"
    [class]="panelStyleClass"
    style="display: none"
    appendTo="body"
  >
    <div #listWrapper class="bfx-dropdown-selector-wrapper">
      <div class="header" *ngIf="!optionSingleSelection">
        <button class="bfx-button-secondary-subtle" (click)="clearAll()">Clear All</button>
      </div>
      <ul #optionElemContainer class="bfx-multi-selector-options">
        <li
          #optionElem
          *ngFor="let option of shownOptions; let i = index"
          [ngClass]="{'selector-autocomplete-list-item':true,'disable': i > lastActiveIndex, 'selector-state-highlight':(highlightIndex==i)}"
          (mousemove)="onMouseMoveHighlight($event, option, optionElem, i)"
          (click)="onClick($event, option, optionElem, i)"
        >
          <label class="label" title="{{option.label}}"><span>{{option.label}}</span></label>
          <div class="bfx-checkbox-default icon" [ngClass]="{'icon-check' : option.checked}"></div>
        </li>
      </ul>
    </div>
  </div>
</div>
